import type { IntlShape } from "@formatjs/intl";
import { Progress } from "antd";
import { palette } from "../../app/theme";
import { NoData } from "./NoDataComp";

type CompletionProgressProps = {
	completedCount: number;
	totalCount: number;
	intl: IntlShape;
};

const getCompletionColor = (completionPercent: number): string => {
	if (completionPercent >= 100) return palette.dashGreen;
	if (completionPercent >= 67) return palette.dashBlue;
	if (completionPercent >= 34) return palette.dashOrange;
	return palette.dashRed;
};

export const CompletionProgress = ({
	completedCount,
	totalCount,
	intl,
}: CompletionProgressProps) => {
	if (totalCount === 0) {
		return <NoData intl={intl} />;
	}

	const completionPercent = Math.round((completedCount / totalCount) * 100);

	return (
		<Progress
			percent={completionPercent}
			format={() => `${completedCount}/${totalCount}`}
			strokeColor={getCompletionColor(completionPercent)}
			size="small"
		/>
	);
};
